module.exports = __webpack_public_path__ + "img/ea_bg3.0fd1731b.jpg";